export class Storage
{
    static STORAGE_ID = 'tmplvision-storage';

    // Note: This needs to be a flat data structure
    static DEFAULT_DATA = {
        "sessionToken" : null,
        "region" : null
    };

    saveSessionToken( sessionToken )
    {
        this.save( "sessionToken", sessionToken );
    }

    loadSessionToken()
    {
        return this.load( "sessionToken" );
    }

    deleteSessionToken()
    {
        this.save( "sessionToken", null );
    }

    saveRegion( region )
    {
        this.save( "region", region );
    }

    loadRegion()
    {
        return this.load( "region" );
    }

    load( key, defVal = null )
    {
        const sd = this.loadStorageData();
        if ( sd.hasOwnProperty( key ) )
        {
            return sd[ key ];
        }
        else
        {
            return defVal;
        }
    }

    save( key, val )
    {
        const sd = this.loadStorageData();
        sd[ key ] = val;
        this.saveStorageData( sd );
    }

    saveStorageData( updatedSd )
    {
        localStorage.setItem( Storage.STORAGE_ID, JSON.stringify( updatedSd ) );
    }

    loadStorageData()
    {
        let sd = localStorage.getItem( Storage.STORAGE_ID );
        if ( sd && sd.length )
        {
            try
            {
                sd = JSON.parse( sd );
            }
            catch( e )
            {
                sd = {};
            }
        }
        return { ...Storage.DEFAULT_DATA, ...sd };
    }
}
